export const PROVIDERS = {
    GOOGLE: 'google',
    FACEBOOK: 'facebook',
    SKOLON: 'skolon',
}
